<template>
   <div class="vertical-center " > 
      <div class="container  ">
         <div class="card login" >
            <div class="card-body">
               <div class="name">
<!--                 <img  :src="image" /> -->
<!--                <h2>Qaller</h2> -->
<!--                 Quality Radio Caller App  -->
                <img class="logo" src="../assets/images/qaller.png" />
               <!-- <p class="talk">Talk</p> -->
               </div>

               <form @submit.prevent="login"  class="text-center" >
                  <div class="form-group">
                     <input type="text" class="form-control" placeholder="Please enter your name....." name="name" v-model="name"  v-on:keyup="clearError"  >
                     <p v-if="errorText" class="text-danger">{{errorText}}</p>
<!--                      <p v-if="errorText" class="text-danger">{{errorText}}</p> -->
                  </div>
                  <div  class="alert alert-info" >
                     Your browser will ask you to allow the use of your microphone. You MUST allow this. If you do not allow the use your microphone, no-one will be able to hear you.
                  </div>
                     <button class="btn btn-primary"  ref="submitBtn"  >Login</button>
               </form>
            </div>
         </div>
      </div>
      <!-- {{date}} -->
      <!-- <button v-on:click="Check1">Check123</button> -->
   </div>
</template>

<script>
   import image from "../assets/images/logo.png"
   import {isMobile} from 'mobile-device-detect';
   import {micSource, vuVis , Ring} from '../../public/js/helper.js';
   import {wsSock} from '../../public/js/comms.js';
   import json_errorText from './../assets/JSON/errorText.json';
  
export default {
   name : 'Login',
   props : {
      errText: String,
   },
   data() {
      return {
         name: "" ,
         errorText:null,
         image : image,
         ctx : null,
         mic: null , 
         got_mic : null , 
         micvis: null ,
         ring : null, 
         wss : null,
         feedbackfromWS: null,
         peers: {},
         errorTranslation: json_errorText,
         date: new Date(),
      }
   },
   beforeMount() {
      this.wss  = new wsSock(),
      this.wss.open();
      this.wss.onpeer = this._onpeer.bind(this);
      
      this.errorText = this.errText;
      this.wss.onreject = (call, id) => {
         if(call == 'setid') {
            this.errorText = "The name '"+id+"' is currently in use. Please enter a different name" ;
//             this.errorText = "The name '"+id+"' is currently in use. If you were redirected to this page please wait a moment before using the same name again. Alternatively if you keep having trouble login in please use a different name.";
            this.feedbackfromWS = 'reject' ;
         }
      };
      this.wss.onaccept = (call, id) => {
         if(call == 'setid') {
            this.feedbackfromWS = 'accept' ;
            this.$router.push({
               name : 'Home',
               params : {
                  wss : this.wss, 
                  username : this.name, 
                  studiocaller : this, 
                  isMobile : isMobile, 
                  mic : this.mic, 
                  ctx : this.ctx,
                  date : this.date
               /*, message: this.message */},
            })
         }
      };
      this.wss.onalert = (t) => {
         this.errorText = 'wss : '+t; 
         localStorage.errorText = 'wss : '+t;
         
         t  = t.replace(/ *\([^)]*\) */g, " ");
         t  = t.replace("+ act  +","");
         var replaced_key  = '' ; 
         this.errorText = '';
         for (var  key in json_errorText) {
               var  value = json_errorText[key];
               replaced_key  = key.replace("+ act  +","");
               replaced_key = "wsSock: "+ replaced_key ;
               if(replaced_key  == t ) {
                     //  alert('replaced_key: '+ replaced_key );
                     this.errorText = value ;
                     if (value == "The connection to the server has been lost" ) {
                        // alert('Check123');
                        value = '';
                        localStorage.errorText = value;
                        // this.studiocaller.wss.close();
                        document.location.reload(true); 
                     }

                  this.errorText = value;
               }
         }
         console.log('wss : '+t);
      }

      
   },
   mounted:function() {
      if (localStorage.name) {
         this.name = localStorage.name;
      }   
      
      if(localStorage.errorText) {
         this.errorText= localStorage.errorText ;
         window.localStorage.removeItem('errorText');
         // localStorage.errorText='';
         //  alert('Check');
      } 
      
      this.wss.onclose = () => {
         this.wss.send({cmd:'log', data: this.date+' user: '+this.name+' -> : Login Comp. :  onclose callback function'});
         this.$forceUpdate();
         // this.$destroy();
      };
      
      window.onpopstate = function(event) {
         location.reload();
      };
      
   },
   methods: {
      login() {
         this.name = this.name.trim();
         if(this.name) {
            this.setId_name(this.name);
            if(!this.errorText) {
               if(this.name) {
                  localStorage.name = this.name; 
               }
               if(isMobile) {
                  this.wss.send({cmd:'log', data: 'user: '+this.name+' -> Mobile device detected'});
                  this.setid(1);
               } else {
                  this.setid(0);
                  this.wss.send({cmd:'log',data:'user: '+this.name+' -> Non-mobile device detected'});
               }
            }
         } else {
            this.errorText = "Please enter a name" 
         }
      },
      setId_name(name) {
         return this.wss.setid(name);
      },
      get_onpeer() {
         return this.wss.peers;
      },
      _onpeer() {
         
         this.peerPar = '';
         var ringing = false;
         Object.keys(this.wss.peers).forEach((id,_) => {
            var p = this.wss.peers[id];
            if(p.deleted) {
               delete this.wss.peers[id];
            }
         });
      },
   
    // simple N-1 conference

      open() {
         alert('Open2');
         console.log('app open');
         this.wss.open();
      },
      
      close() {
         // console.log('app close');
         this.wss.send({cmd:'log', data: 'user: '+this.name+' -> : Login Comp. : close Method'});
         this.wss.close();
      },
      
      setid(lite) {
         console.log('app setid: ' + lite);
         if(!this.ctx) {
            let AudioContext = window.AudioContext || window.webkitAudioContext;
            this.ctx = new AudioContext();
         }
         if(!this.ring) {
            this.ring = new Ring(this.ctx);
            this.ring.load('ring3', '../sounds/ring3.u16');
         }
         if(!this.mic) {
            this.mic = new micSource(this.ctx);
            // alert('onopentest1');
            this.mic.onopen = () => {
               console.log('got mic: ', lite);
               if(lite) {
                  this.wss.setaudio(this.ctx, this.mic._stream);
               } else {
                  this.wss.setaudio(this.ctx);
               }
               this.got_mic = true;
               this.wss.onpeer(); // update peer display once mic is open...
            }
         }
      },
    
      create_canvas(micCanvas) {
         if(!this.micvis) {
            this.micvis = new vuVis(this.ctx, micCanvas);
            console.log('MicVis: ');
            console.log(this.micvis);
            this.mic.connect(this.micvis);
         }
      } ,
      
      clearError() {
         this.errorText = '';
      },
      Check1() {
         this.errorText='Chesdck'
      },
      login_test() {
         console.log('login_test');
         console.log(localStorage.name);
         this.setId_name(localStorage.name);
      },
   },
   computed: {

   },
   watch: {
//       '$route' (to, from) {
//          console.log('to' + to);
//          console.log('from ' + from );
//          this.init();
//       }
   },

   
   }
</script>

<style>
   .login {
      max-width   : 450px; 
      margin      : 50px;
      display     : block; 
      margin-left : auto; 
      margin-right: auto ; 
   }
   .vertical-center {
      min-height: 100%; 
      min-height: 90vh;
      display: flex ;
      align-items: center;
   }
   .name {
      margin-bottom: 5px;
   }
   
   .logo {
      width : 120px;
      display: block;
      margin-left: auto;
      margin-right: auto;
   }

   .text-danger{
      text-align: justify;
      margin : 10px 0 10px 0;
   }
   
</style>
